<router-outlet />
<app-bottom-nav />
<app-install-prompt />
<app-snackbar-host />
<app-confirm-dialog-host />
